import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Location,
  NavigateFunction,
  useLocation,
  useNavigate,
} from 'react-router-dom'
import type { Track } from 'types/track'
import { updateUserSettingsUnsafe } from '@disco/state-management/actions/ExplorerActions'
import { confirmTrackMerge } from '@disco/state-management/actions/FormActions'
import { TRACK } from '@disco/constants/ItemTypes'
import { getAllSelectedItems } from '@disco/state-management/selectors/selection'
import { getHideMergeWarningSetting } from '@disco/state-management/selectors/user'
import DocumentHeadTags from 'components/document-head-tags'
import MergeConfirmationDialog from 'components/modals/dialogs/merge-confirmation-dialog'
import { getSelectionBase } from 'utils/routing'

function mapStateToProps(state) {
  const selectedItems = getAllSelectedItems(state)
  return {
    trackCount: selectedItems.filter(
      item =>
        item.type === TRACK && !(item as any as Track).outside_your_territories,
    ).length,
    hideMergeWarning: getHideMergeWarningSetting(state),
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateUserSettingsUnsafe,
      confirmTrackMerge,
    },
    dispatch,
  )
}

// Define connector
const connector = connect(mapStateToProps, mapDispatchToProps)

// Infer props type from Redux
type PropsFromRedux = ConnectedProps<typeof connector>

// Own props interface
interface OwnProps {
  navigate: NavigateFunction
  location: Location
}

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

class SelectionRemove extends React.Component<Props> {
  _onClose = () => {
    this.props.navigate(`${getSelectionBase(this.props.location.pathname)}/merge`)
  }
  _onConfirm = () => {
    this.props.confirmTrackMerge()

    this._onClose()
  }
  _hideWarning = () => {
    this.props.updateUserSettingsUnsafe({
      settings: {
        hide_merge_warning: !this.props.hideMergeWarning,
      },
    })
  }

  render() {
    return (
      <div>
        <DocumentHeadTags title="Merge tracks | DISCO" />
        <MergeConfirmationDialog
          onConfirm={this._onConfirm}
          onCancel={this._onClose}
          trackCount={this.props.trackCount}
          onHideWarningChange={this._hideWarning}
          hideWarning={this.props.hideMergeWarning}
        />
      </div>
    )
  }
}

const ConnectedSelectionRemove = connector(SelectionRemove)

function SelectionRemoveWithRouter(props: any) {
  const navigate = useNavigate()
  const location = useLocation()
  return (
    <ConnectedSelectionRemove
      {...props}
      navigate={navigate}
      location={location}
    />
  )
}

export default SelectionRemoveWithRouter
